export const DOMAIN_QUOTA_SCOPE = 'domain';
export const PROJECT_QUOTA_SCOPE = 'project';
export type QUOTA_SCOPE = typeof DOMAIN_QUOTA_SCOPE | typeof PROJECT_QUOTA_SCOPE;
export const AVAILABLE_QUOTA_SCOPES = [DOMAIN_QUOTA_SCOPE, PROJECT_QUOTA_SCOPE];
